import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

// @param slotData: object
// example:
// {
//   "day_of_the_week": "sunday",
//   "start_time": "10:00",
//   "end_time":"20:00"
// }
export function createTutorNote(slotData: object): Promise<ApiResponse> {
  return Axios.post(`v1/tutors/notes`, slotData);
}

export function updateTutorNote(
  noteId: number,
  data: object
): Promise<ApiResponse> {
  return Axios.put(`v1/tutors/notes/${noteId}`, data);
}

export function indexStudentNotes(filters: object): Promise<ApiResponse> {
  return Axios.get("v1/tutors/notes/index_note", {
    params: filters,
  });
}
export function indexStudentNotesById(
  id: string | number,
  filters: object
): Promise<ApiResponse> {
  return Axios.get(`v1/tutors/notes/index_note?student_id=${id}`, {
    params: filters,
  });
}
export function removeNotes(noteId: number): Promise<ApiResponse> {
  return Axios.delete(`/v1/tutors/notes/${noteId}`);
}
